import UIComponent from "../../common/UIComponent";
import "./index.css";

/**
 * 播放/暂停按钮元素组件
 */
export default class PlayBtn extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.isplay = false;
    this.init();

    // todo: display?
    // this.interfaces.on(VhallPlayer.LOADED, res => {
    //   this.playBtn.style.display = "block";
    // });

    this.interfaces.on(VhallPlayer.PLAY, res => {
      this.isplay = true;
      this.playBtn.setAttribute("class", "vhallPlayer-playBtn pause");
    });

    this.interfaces.on(VhallPlayer.PAUSE, res => {
      this.isplay = false;
      this.playBtn.setAttribute("class", "vhallPlayer-playBtn play");
    });
  }

  init() {
    this.playBtn = document.createElement("span");
    // this.playBtn.style.display = "none";
    this.playBtn.setAttribute("class", "vhallPlayer-playBtn play");
    this.playBtn.onclick = this.handlPlayBtnClick.bind(this);
    this.insertElement(this.elementId, this.playBtn);
  }

  handlPlayBtnClick() {
    !this.isplay ? this.interfaces.play() : this.interfaces.pause();
  }

}